export const DEVICE_BREAKPOINTS = {
  XS: "390px",
  SM: "425px",
  MD: "768px",
  LG: "1024px",
  XL: "1280px",
};
